export default __webpack_public_path__ + "static/media/net.98dd8f19.svg";